var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-stretch",attrs:{"id":"tag-page"}},[_c('navigation'),_c('reports-manager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }